function getOpt (dataObj) {
 let xData = dataObj.xData;
 let yData = dataObj.yData;
 let alarmData = dataObj.alarmData;
 let basisData = dataObj.basisData;
 let markPointArr = []
 let hasTooltip = []
 for (let i = 0; i < yData.length; i++) {
  if (yData[i] > basisData.basisValue) {
   if (alarmData[i]) {
    markPointArr.push({ coord: [i, yData[i]], symbol: 'circle', })
   } else {
    markPointArr.push({ coord: [i, yData[i]], symbol: 'triangle', })
   }
   hasTooltip.push(i)
  }
 }
 return {
  backgroundColor: 'transparent',
  tooltip: {
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   },
   axisPointer: {
    lineStyle: {
     color: '#57617B',
     fontSize: 20
    }
   },
   formatter: function (params) {
    if (!hasTooltip.includes(params[0].dataIndex)) return ``
    var htmlStr = `<div><span style="color:#fff;font-size:16px;">${params[0].name}</span><br/>`;
    htmlStr +=
     '<span style="width: 10px;height: 10px;display:inline-block;border-radius: 50%;background-color:' +
     params[0].color + '"></span><span style="color:#fff;font-size:16px;">' + '  ' +
     basisData.type + ':</span>' + '<span style="color:#fff;font-size:16px;">' +
     (params[0].value ? params[0].value : '-') + '&nbsp;' + basisData.unit + '</span><br/>';
    htmlStr += `<span style="width: 10px;height: 10px;display:inline-block;border-radius: 50%;background-color:
    ${params[0].color}"></span><span style="color:#fff;font-size:16px;">  前五分钟预警次数: ${alarmData[params[0].dataIndex]}</span></div>`
    return htmlStr;
   }
  },
  legend: {
   icon: 'rect',
   show: true,
   itemWidth: 20,
   itemHeight: 3,
   itemGap: 13,
   right: '4%',
   textStyle: {
    fontSize: 16,
    color: 'rgba(200, 221, 225, 1)'
   },
   selectedMode: false
  },
  grid: {
   top: "15%",
   left: '4%',
   right: '10%',
   bottom: '0%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   boundaryGap: false,
   axisLine: {
    lineStyle: {
     width: 2,
     color: {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
       offset: 0, color: '#3E86DB' // 0% 处的颜色
      }, {
       offset: 1, color: '#B8FFFB' // 100% 处的颜色
      }],
      global: false // 缺省为 false
     }
    }
   },
   axisLabel: { //坐标轴刻度标签的相关设置
    textStyle: {
     color: 'rgba(215,215,215,1)',
     fontSize: 14,
     margin: 15,
    },
   },
   axisTick: {
    show: false,
   },
   data: xData
  }],
  yAxis: {
   type: 'value',
   name: `${basisData.type}(${basisData.unit})`,
   nameTextStyle: {
    fontSize: 18,
    padding: [0, -20, 30, 0],
    color: "rgba(215,215,215,1)",
   },
   axisTick: {
    show: true
   },
   axisLine: {
    show: false,
    lineStyle: {
     color: 'rgb(249, 249, 249)'
    }
   },
   axisLabel: {
    margin: 10,
    textStyle: {
     color: "rgba(215,215,215,1)",
     fontSize: 14
    }
   },
   splitLine: {
    lineStyle: {
     color: 'rgba(48, 95, 115,.3)'
    }
   }
  },
  series: [{
   name: `${basisData.type}监测点`,
   type: 'line',
   smooth: true,
   symbol: 'circle',
   symbolSize: 5,
   showSymbol: false,
   lineStyle: {
    normal: {
     width: 2,
     color: "rgba(75, 224, 255, 1)"
    }
   },
   areaStyle: {
    normal: {
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 224, 255, 0.2)'
     }, {
      offset: 0.3,
      color: 'rgba(75, 224, 255, 0.05)'
     }, {
      offset: 1,
      color: 'rgba(75, 224, 255, 0)'
     }], false),
     shadowColor: 'rgba(62, 234, 236, 0)',
     shadowBlur: 10
    }
   },
   itemStyle: {
    normal: {
     color: "rgba(62, 234, 236, 1)",
    }
   },
   markLine: {
    symbol: "none",
    data: [{
     type: "average",
     yAxis: basisData.basisValue    //警戒线在y轴的坐标
    }],
    silent: true,
    precision: 1,
    label: {
     show: true,
     color: '#8DE4F3',
     fontSize: 14,
     padding: [0, 0, 0, 0],  // 重点在这里，这个地方就是定位
     position: 'end',
     formatter: `浓度限值\n    ${basisData.basisValue}`
    }
   },
   markPoint: {
    symbolSize: 20,
    data: [...markPointArr],
    label: {
     show: true
    },
   },
   data: yData,

  }]
 };
}

export default getOpt;